import { createReducer } from "reduxsauce";
import _ from "lodash";
import UIDs from "../../../UIDs";

import ReducerRegister from "../../ReducerRegister";
import { ActionTypes } from "../../actionTypes/screens/talkchinese/PracticeResultActionTypes";
import PracticeResultService from "../../../services/screens/talkchinese/PracticeResultService";
import AsyncActionReducers from "../../AsyncActionReducers";

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (vo, result) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC });

            PracticeResultService.loadScreenView(
                vo,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response, result, vo.practiceRole));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (data, result, practiceRole) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
        result,
        practiceRole
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    updateUnitResultAsync: (unitResult) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.UPDATE_UNIT_RESULT_ASYNC });

            PracticeResultService.updateUnitResult(
                unitResult,
                response => {
                    dispatch(Actions.updateUnitResultSuccess(response));
                },
                error => {
                    dispatch(Actions.updateUnitResultFailure(error));
                }
            );
        };
    },

    updateUnitResultSuccess: (data) => ({
        type: ActionTypes.UPDATE_UNIT_RESULT_SUCCESS,
        parentType: ActionTypes.UPDATE_UNIT_RESULT_ASYNC,
        data
    }),

    updateUnitResultFailure: error => ({
        type: ActionTypes.UPDATE_UNIT_RESULT_FAILURE,
        parentType: ActionTypes.UPDATE_UNIT_RESULT_ASYNC,
        error
    }),

};

//
// Initial State
//
const INITIAL_STATE = {
    data: null,
    result: null,
};

//
// Reducers
//
const buildData = (unit, practiceRole) => {
    const { id, unitType = "", score, data: unitData, answer, files, totalScore, rank, useState, vipEnabled } = unit;

    let data = { unitType, ...JSON.parse(unitData || null), id, totalScore, rank, useState, vipEnabled: true };
    let result = { score, answer: JSON.parse(answer || null), files: JSON.parse(files || null) };

    let singleData = data.singleUnits[0];
    if (unitType === 'POKA1') {
        singleData.practiceRole = practiceRole;
    }
    data = { ...data, ...singleData };

    return { data, result };
};

const loadScreenViewSuccessPostReducer = (state, { data, result, practiceRole }) => {
    let { unit } = data;
    return { ...state, ...buildData(unit, practiceRole), result };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.UPDATE_UNIT_RESULT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.UPDATE_UNIT_RESULT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.UPDATE_UNIT_RESULT_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(UIDs.screens.talkchinese.practiceresult, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
